
angular.module('bmsApp.settings').controller('LicenseDetailCtrl',
	function ($scope, $log, $state, LicenseDetailSvc, notify, AuthService, $window, SiteSvc) {

		$scope.license = {};
		$scope.licenses = [];
		$scope.showLicenseForm = false;
		$scope.processing = false;
		$scope.formValidator = {};
		$scope.tinymceOptions = {
			debounce: false,
			plugins: 'link image preview colorpicker textcolor',
			elementpath: false,
			statusbar : false,
			menu: {},
			height: "250",
			toolbar: 'bold italic fontsizeselect forecolor  alignleft aligncenter alignright  bullist numlist link undo redo  preview'
		};
		$scope.formvalidatorconfig = {
			submitHandler: function (form) {
				$scope.submit($scope.license);
			}
		};

		LicenseDetailSvc.index().then(function (response) {
			$scope.emails = response.data.business_emails;
			$scope.telephones = response.data.business_phone;

			$scope.licenseCount = response.data.licenses.length;
			if ($scope.licenseCount >= 1){
				$scope.licenses = response.data.licenses;
			}
			else {
				$scope.addLicense();
			}
		});

		$scope.addressLookup = function() {
			return SiteSvc.lookup({postcode: $scope.license.postcode_lookup, houseNo: $scope.license.houseno_lookup}).then(function(response) {
				$scope.addressList = response.data.addresses;
				if ($scope.addressList.length === 1) {
					let address = $scope.addressList[0];
					$scope.license.invoice_address_line_1 = address.line_1 || '';
					$scope.license.invoice_address_line_2 = address.line_2 || '';
					$scope.license.invoice_address_line_3 = address.line_3 || '';
					$scope.license.invoice_city = address.city || '';
					$scope.license.invoice_county = address.county || '';
					$scope.license.invoice_postcode = address.postcode || '';
					$scope.license.showLookup = false;
				}
			}, function() {
				notify({
					message: 'Address not found',
					classes: 'error',
				});
			});
		};

		$scope.addressChanged = function(address) {
			$scope.license.invoice_address_line_1 = address.line_1;
			$scope.license.invoice_address_line_2 = address.line_2;
			$scope.license.invoice_address_line_3 = address.line_3;
			$scope.license.invoice_city = address.city;
			$scope.license.invoice_county = address.county;
			$scope.license.invoice_postcode = address.postcode;
			$scope.license.showLookup = false;
		};

		$scope.submit = function (license) {
			$scope.processing = true;

			var promise;
			var creating = (license.id) ? false : true;
			promise = (!creating) ?
					LicenseDetailSvc.update(license) :
					LicenseDetailSvc.create(license);

			promise.then(function (response) {
				if (creating) {
					$scope.licenses.push($scope.license);
				}
				$scope.licenseCount = $scope.licenses.length;
				$scope.showLicenseForm = false;

				if ($state.is('main.settings.licenseDetails')){
					notify({
						message: 'Successfully saved'
					});
				}
				else{
					// Save the new license back to the session so we have the permission to access network related stuff
					var userInfo = AuthService.getUser();
					var licenseName = '';
					if (license.license_type_id == 1){
						licenseName = "Merry Maids";
					}
					else if (license.license_type_id == 2){
						licenseName = "Furniture Medic";
					}
					else if (license.license_type_id == 3){
						licenseName = "TruGreen";
					}
					else if (license.license_type_id == 3){
						licenseName = "ServiceMaster Clean";
					}


					var exists = false;
					angular.forEach(userInfo.licenses, function(lic){ // check it doesn't exists already
						if (lic == licenseName){
							exists = true;
						}
					});
					if (!exists){
						if (userInfo.licenses instanceof Array){
							userInfo.licenses = [licenseName];
						}
						AuthService.saveToSession();
					}

				}
			}, function (error) {
				$scope.errors = error;
			})
				.finally(function () {
					$scope.processing = false;
				});

		};

		$scope.viewPaymentInfoPreview = function() {
			$scope.loadingPaymentInfoPreview = true;
			LicenseDetailSvc.viewPaymentInfoPreview({
				license: $scope.license,
			}).then((response) => {
				$scope.loadingPaymentInfoPreview = false;
				$window.open(response.data.file.url);
			});
		};

		$scope.resetAddress = function(){
			$scope.license.invoice_address_line_1 = "";
			$scope.license.invoice_address_line_2 = "";
			$scope.license.invoice_address_line_3 = "";
			$scope.license.invoice_city = "";
			$scope.license.invoice_county = "";
			$scope.license.invoice_postcode = "";
		};

		$scope.editLicense = function (license) {
			$scope.license = license;
			angular.extend($scope.license, {
				addr: {
					sameAsBusiness: $scope.license.invoice_address_line_1 == ''
				}
			});
			$scope.showLicenseForm = true;
		};

		$scope.addLicense = function () {
			angular.extend($scope.license, {
				id: '',
				license_name: '',
				license_number: '',
				email_address_id: '',
				terms: '',
				next_invoice_no: '',
				payment_information: '',
				invoice_address_line_1: '',
				invoice_address_line_2: '',
				invoice_address_line_3: '',
				invoice_city: '',
				invoice_county: '',
				invoice_postcode: '',
				addr: {
					sameAsBusiness: true
				}
			});
			$scope.showLicenseForm = true;

		};
		


	});



